export class D2CRefundPolicyRuleDto {
}
